module.exports = __webpack_public_path__ + "img/ill_authorization_up@2x.4d90b108.png";